import React from 'react';

import { useTheme, makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Grid, Typography, TableContainer, Table, TableBody, TableRow, TableCell } from '@material-ui/core';

import FirmaOS from 'assets/images/firmaos.png';

interface ComponentProps {
  data: any
}

export default function ObleaDesinfeccionCABA(props: ComponentProps) {
  const theme = useTheme();
  const classes = useStyles();

  if (props.data) {
    return (
      <React.Fragment>
        <Grid container justify="center" alignItems="center"
          style={{ padding: theme.spacing(2), backgroundColor: theme.palette.primary.main }}
        >
          <Grid item >
            <Typography variant="h6" style={{ color: "#ffffff", textAlign: 'center', fontSize: '1rem' }}>
              CERTIFICADO DE DESINFECCION
            </Typography>
          </Grid>
        </Grid>
        <TableContainer>
          <Table className={classes.table} aria-label="simple table">
            <TableBody>
              {props.data.map((row: any) => (
                <TableRow key={row.item}
                  style={{
                    backgroundColor: (row.id % 2) ? "#ffffff" : "#E3E9F0",
                    color: (row.id % 2) ? '#333333' : '#000000',
                  }}
                >
                  <TableCell align="left" style={{
                    color: 'inherit', fontWeight: 'bold',
                    whiteSpace: (row.id === 0 || row.id === 6) ? 'nowrap' : 'normal'
                  }}>{row.item}</TableCell>
                  <TableCell align="left" style={{ color: 'inherit' }}>{row.descripcion}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Grid container justify="flex-end" style={{ backgroundColor: '#ffffff' }}>
          <Grid item>
            <div style={{ marginBottom: 60 }}>
              <img src={FirmaOS} alt="" style={{ maxHeight: 180 }}
                className="float-left img-responsive"
              />
              <div style={{ maxWidth: 200, marginTop: -60, textAlign: 'center', fontSize: 11 }}>
                <p>Ing en Construcciones OSVALDO SALTI Higiene y Seguridad Industrial, Contaminacion Ambiental
                Registro GCABA de Directores Tecnicos de Empresas Privadas de Desinfeccion y Desinsectacion Bajo el Nro 1599
            </p>
              </div>
            </div>
          </Grid>
        </Grid>
      </React.Fragment >
    );
  } else {
    return (
      <React.Fragment>
      </React.Fragment>
    )
  }
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    table: {
      minWidth: 300,
    },
    paper: {
      padding: theme.spacing(2),
      display: 'flex',
      overflow: 'auto',
      flexDirection: 'column',
    },
    title: {
      margin: theme.spacing(2),
    }
  }),
);
